//
import React, { FC, ReactNode, useMemo, useState } from 'react';
import { ProspectInformation } from '../../../interfaces/ProspectInformation';
import ProspectContext from '../ProspectContext';

export interface ProspectProviderProps {
  prospectInfo?: ProspectInformation;
  children: ReactNode;
}

const ProspectProvider: FC<ProspectProviderProps> = ({ children, prospectInfo }) => {
  const defaultProspectInfo: ProspectInformation = { isProspect: false };
  const [currentProspectInfo, setCurrentProspectInfo] = useState(prospectInfo || defaultProspectInfo);

  const saveProspectInfo = (values: ProspectInformation) => {
    setCurrentProspectInfo(values);
  };

  const prospectContextProviderValue = useMemo(() => ({ prospectInfo: currentProspectInfo, saveProspectInfo }), [currentProspectInfo]);

  return (
    <ProspectContext.Provider value={prospectContextProviderValue}>
      {children}
    </ProspectContext.Provider>
  );
};

/**
 * @deprecated ProspectProvider has been deprecated. Please use UserAccountProvider instead.
 */
export default ProspectProvider;
